import { css } from '@emotion/react';
import { Tip } from 'src/constants/tips';

const tipCard = () => css`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 245px;
  height: 157px;
  padding: 24px 0px 0px 0px;
`;
const headerStyle = () => css`
  font-weight: 600;
  align-self: flex-start;
  padding: 16px 0px 0px 0px;
  font-size: 14px;
`;

const descriptionStyle = () => css`
  align-self: flex-start;
  font-size: 12px;
  font-weight: 300;
  padding-top: 2.5px;
`;

export const TipCard = ({ img, description, header }: Tip) => (
  <div css={tipCard}>
    <img height={85} src={img} alt={header} />
    <div css={headerStyle}>{header}</div>
    <div css={descriptionStyle}>{description}</div>
  </div>
);
